import {useSelector} from "react-redux";

const useCompanyUser = () => {
  const user = useSelector(state => state.user);
  
  return { user };
};

export default useCompanyUser;
